// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1FKH_","overflowing":"ReadFullNote_overflowing__1R7qy"};